export default "__VITE_ASSET__U82_TZBI__"